var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-top-to",on:{"click":_vm.targetToTop}},[_c('i',{staticClass:"ti-angle-up"})])
}
var staticRenderFns = []

export { render, staticRenderFns }